import React from 'react';
import ApprovalNowListContainer from './ApprovalNowListContainer';
const DashboardApprovalContainer = () => {
  return (
    <>
      <ApprovalNowListContainer />
    </>
  );
};

export default DashboardApprovalContainer;
